import { InMemoryCache } from '@apollo/client'

import { getPossibleGraphqlTypes } from '../helpers'

class ApolloCache {
  constructor() {
    this.cache = new InMemoryCache({
      possibleTypes: {},
    })
  }

  async setPossibleTypes({ uri }) {
    const possibleTypes = await getPossibleGraphqlTypes(uri)

    this.cache = new InMemoryCache({
      possibleTypes,
    })
  }
}

export default ApolloCache
